import { API_CONFIG } from './api';
import { HttpClient } from '../utils/httpClient';
import {
  FlowStatusResponse,
  GroupStrategy,
  SortDirection,
  UploadInitiationResponse,
  UploadResponse,
} from '../types';

/**
 * Smart Review API Service
 * Handles all API calls related to file mapping operations
 */
export class SmartReviewService {
  private httpClient: HttpClient;

  constructor(baseURL: string = API_CONFIG.baseURL) {
    this.httpClient = new HttpClient(baseURL);
  }


  /**
   * Upload file for async processing - returns flow_id immediately
   */
  async uploadFileAsync(
    file: File,
    includeImages: boolean = true,
    groupStrategy: GroupStrategy = 'firm_first',
    direction: SortDirection = 'asc',
    processFirms: boolean = true,
    processMarketing: boolean = true
  ): Promise<UploadInitiationResponse> {
    return this.httpClient.uploadFile<UploadInitiationResponse>(
      '/api/v1/upload/async',
      file,
      {
        include_images: includeImages.toString(),
        group_strategy: groupStrategy,
        direction,
        process_firms: processFirms.toString(),
        process_marketing: processMarketing.toString(),
      }
    );
  }

  /**
   * Get flow status for polling
   */
  async getFlowStatus(flowId: string): Promise<FlowStatusResponse> {
    return this.httpClient.request<FlowStatusResponse>(
      `/api/v1/flow/${flowId}/status`,
      { method: 'GET' }
    );
  }

  /**
   * Get flow data by ID
   */
  async getFlowData(flowId: string): Promise<UploadResponse> {
    return this.httpClient.request<UploadResponse>(
      `/api/v1/flow/${flowId}/data`,
      { method: 'GET' }
    );
  }

  /**
   * Download processed file by download ID
   */
  async download(downloadId: string): Promise<Blob> {
    return this.httpClient.requestBlob(
      `/api/v1/download/${downloadId}`,
      { method: 'GET' }
    );
  }

}

// Export singleton instance
export const smartReviewService = new SmartReviewService();